<template>
    <dash
        icon="fa fa-envelope"
        titulo="MENSAGENS"
        @click.native="$router.push({ name: 'Mensagens' })"
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	props: {
		qtd: {
			type: Number
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
